import { IconButton } from "@anna-money/anna-web-ui";
import type { FC } from "react";
import { LogoIcon } from "../../../icons/icons";
import type { Pp2ViewModel } from "../pp2ViewModel";
import type { Pp2CopyFeedback } from "../shared/useCopyFeedback";
import styles from "./pp2PayForm.module.scss";

type Pp2BankDetailsProps = {
  bank: Pp2ViewModel["bank"];
  copy: Pp2CopyFeedback;
};

/**
 * "Or pay by bank transfer manually" (spec 3.4 item 9, 5.4): the holder's bank details and a copy
 * button whose icon turns into a tick for 1.5s, announced by a visually hidden live status.
 */
export const Pp2BankDetails: FC<Pp2BankDetailsProps> = ({ bank, copy }) => {
  const copied = copy.copiedKey === "bank";

  return (
    <section className={styles.manual}>
      <h3 className={styles.manualTitle}>Or pay by bank transfer manually</h3>
      <div className={styles.bankCard} role="group" aria-label="Bank details" data-test-id="pp2-bank-details">
        <span className={styles.bankLogo} aria-hidden="true">
          <LogoIcon width="28" height="28" />
        </span>
        <div className={styles.bankText}>
          <span className={styles.bankHolder}>{bank.holder}</span>
          <span>Sort code: {bank.sortCode}</span>
          <span>Account#: {bank.accountNumber}</span>
        </div>
        <IconButton
          className={styles.copyButton}
          icon={copied ? "actionTick" : "actionDuplicate"}
          iconColor="themeGreen"
          size="m"
          title="Copy bank details"
          onClick={() => {
            copy.copy("bank", bank.copyText);
          }}
        />
        <span className={styles.srOnly} role="status">
          {copied ? "Bank details copied" : ""}
        </span>
      </div>
    </section>
  );
};
